import resourceList from '../resource_list';
import rest from '../rest';

async function resendCodeCustomer() {
  return rest.getAcl(resourceList.AUTH, '/customer/resend-activation-code');
}

export default resendCodeCustomer;
